import { useEffect, useState } from 'react';

/**
 * Seconds remaining until a fixed ISO moment, ticking once a second.
 *
 * Returns null when there is no target (or an unparseable one), so a caller can
 * distinguish "no session" from "0 seconds left". Because it counts down to an
 * absolute server timestamp rather than from a duration, a reload shows the true
 * remaining time instead of restarting the clock.
 */
export function useSecondsLeft(expiresAt: string | null | undefined): number | null {
  const [left, setLeft] = useState<number | null>(null);
  useEffect(() => {
    if (!expiresAt) { setLeft(null); return; }
    const target = new Date(expiresAt).getTime();
    if (Number.isNaN(target)) { setLeft(null); return; }
    const tick = () => setLeft(Math.max(0, Math.floor((target - Date.now()) / 1000)));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [expiresAt]);
  return left;
}
